import { Action } from '@ngrx/store';
import { ActionBase } from "../../../core/store/action/ActionBase";

export const ADD_USER_GROUP_ERROR = '[Customer] User Add Group Error';

export class ManageUserGroupErrorAction implements Action {
  readonly type = ADD_USER_GROUP_ERROR;
  payload: { action: ActionBase, errors: string[] };

  constructor(action: ActionBase, errors: string[]) {
    this.type = ADD_USER_GROUP_ERROR;
    this.payload = {
      action: action,
      errors: errors
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/ManageUserGroupErrorAction.ts